import React from 'react';
import PropTypes from 'prop-types';
import { Illustration } from '@eb/eds-illustration';
import { Divider } from '@eb/eds-divider';

import './EmptyState.scss';

export const EmptyState = (props) => {
    return (
        <>
            <div className="eds-l-pad-bot-8">
                <Divider color="ui-200" />
            </div>
            <section
                className={`empty-state ${props?.containerClassname || ''}`}
            >
                <div className="empty-state__body">{props.children}</div>
                <div className="empty-state__graphic">
                    <Illustration
                        width="100px"
                        height="100px"
                        type={props.illustrationType}
                    />
                </div>
            </section>
        </>
    );
};

EmptyState.propTypes = {
    containerClassname: PropTypes.string,
    illustrationType: PropTypes.node,
};
